import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import { faqData } from '@/mocks/faqData';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import CategorySection from './components/CategorySection';
import FeatureGrid from './components/FeatureGrid';
import CTASection from './components/CTASection';
import ContentSection from './components/ContentSection';
import ComparisonSection from './components/ComparisonSection';
import FAQSection from './components/FAQSection';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'CSSBuy Spreadsheet',
  url: 'https://cssspreadsheet.click',
  description: 'The ultimate CSSBuy Spreadsheet directory with trusted sellers, buying guides, QC tutorials, and shipping tips.',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://cssspreadsheet.click/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqData.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

export default function Home() {
  return (
    <>
      <JsonLd data={websiteSchema} />
      <JsonLd data={faqSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <CategorySection />
        <FeatureGrid />
        <CTASection />
        <ContentSection />
        <ComparisonSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}